export const icons = {
  globalTeam: "https://img.airhelp.com/i/about-us/icons/Global-team.png",
  wallet: "https://img.airhelp.com/i/about-us/icons/No-win-no-fee-formal.png",
  globe: "https://img.airhelp.com/i/about-us/icons/Available-worldwide-formal.png",
};
